import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs';

@Injectable()
export class TableFixedHeaderService {
  resetTableHeaderScrollLeft = false;
  resetTableHeaderScrollLeftRaw$ = new Subject<Boolean>();

  private resetTableScrollLeftChange$ = this.resetTableHeaderScrollLeftRaw$.pipe(
    tap((value) => (this.resetTableHeaderScrollLeft = Boolean(value)))
  );

  constructor() {
    this.resetTableScrollLeftChange$.subscribe();
  }

  nowResetTableHeaderScrollLeft(value: Boolean) {
    this.resetTableHeaderScrollLeftRaw$.next(value);
  }
}
